import React, { useState, useEffect } from 'react';
import { useMutation } from '@apollo/client';
import { useSelector, useDispatch } from 'react-redux';
import { ADD_EMAIL } from '../../utils/mutations';
import { SIGNUP_MODAL_DISMISSED, SIGNUP_MODAL_FLAG } from '../../utils/actions';


import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';

import './SignupModal.css';

function SignupModal(props) {
  const SIGNUP_SUPPRESS_TIME_KEY = 'oshikem_signup_dismissed';
  const SIGNUP_DONE_KEY = 'oshikem_signup_done';
  const SUPPRESS_TIME_MS = 24*60*60*1000; // don't show again for 1 day

  const [addEmail, { data, loading, error }] = useMutation(ADD_EMAIL);

  const signupModalOpen = useSelector(state => state.signupModalOpen);
  const signupModalDismissed = useSelector(state => state.signupModalDismissed);
  const dispatch = useDispatch();

  const [show, setShow] = useState(signupModalOpen);
  const [email, setEmail] = useState(false);

  useEffect( () => setShow(signupModalOpen),
    [signupModalOpen, setShow]
  );

  function handleEmailEdit(e) {
    setEmail(e.target.value);
  }

  function emailIsValid() {
    const hasAt = /^[^@]+@[^@]+$/;
    const whitespace = /\s/;
    return hasAt.test(email) && ! whitespace.test(email);
  }

  function handleClose(done) {
    setShow(false);
    dispatch({ type: SIGNUP_MODAL_FLAG, show: false });
    dispatch({ type: SIGNUP_MODAL_DISMISSED, dismissed: true });

    localStorage.setItem(SIGNUP_SUPPRESS_TIME_KEY, Date.now().toString());
    if (done) {
      localStorage.setItem(SIGNUP_DONE_KEY, Date.now().toString());
    }
  }

  function handleSubmit() {
    addEmail({ variables: { email, source: 'oshikem.com' } })
      .then(() => console.debug('email added'))
      .finally(() => handleClose(true));
  }

  useEffect(() => {
    setTimeout(() => {
        const signupDone = localStorage.getItem(SIGNUP_DONE_KEY);
        const signupSuppressUntil = SUPPRESS_TIME_MS + Number(localStorage.getItem(SIGNUP_SUPPRESS_TIME_KEY));

        if (! signupDone && ! signupModalDismissed && Date.now() > signupSuppressUntil) {
          dispatch({ type: SIGNUP_MODAL_FLAG, show: true });
        }
      }, 10000);
    }
    ,
    [dispatch, signupModalDismissed, SUPPRESS_TIME_MS]);

  return (
      <Modal show={show} onHide={() => handleClose(false)} className="signup">
        <Modal.Body>
          <p>Join Oshikem’s mailing list for fresh deals and discount codes.</p>

          <Form>
            <Form.Group className="mb-3" controlId="email">
              <Form.Control type="email" placeholder="Your email" onChange={handleEmailEdit} maxLength={80}/>
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="link" onClick={() => handleClose(false)}>Remind me later</Button>
          <Button variant="primary" disabled={! emailIsValid()} onClick={handleSubmit}>Add me!</Button>
        </Modal.Footer>
      </Modal>
  );
}

export default SignupModal;
